import KKey from 'keyboard-key';

const header = window.RB_HEADER;


export function initDesktopHeader() {
    const root = header.desktop;
    const topEntries = [root.querySelector('.-logo'), ...root.querySelectorAll('.-list > .-entry')];

    initMinimizer();
    topEntries.forEach(initDesktopTopEntry);
    // initLogin();


    function initMinimizer() {
        const minimizer = document.createElement('div');
        Object.assign(minimizer.style, {
            pointerEvents: 'none',
            position: 'absolute',
            top: '120px',
            left: 0,
        });
        const minimizeObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    root.classList.remove('is--shrunken');
                    document.body.classList.remove('is--header--shrunken');
                    minimizer.style.top = '120px';
                } else {
                    root.classList.add('is--shrunken');
                    document.body.classList.add('is--header--shrunken');
                    minimizer.style.top = '90px';
                }
            });
        }, {
            rootMargin: '0px',
            threshold: 0,
        });
        document.body.appendChild(minimizer);
        minimizeObserver.observe(minimizer);
    }


    function initLogin() {
        const loginToggler = root.querySelector('.is--login button'),
              login        = document.querySelector('[data-block="Login"]');

        login.inert = true;

        resolveAssignment();
        document.addEventListener('rb.header.switch', resolveAssignment);

        function resolveAssignment() {
            header.getCurrent() === header.desktop ? assign() : unassign();
        }

        function unassign() {
            loginToggler.removeEventListener('click', toggleLogin);
            window.removeEventListener('resize', offsetLogin);
            window.removeEventListener('orientationchange', offsetLogin);
        }

        function assign() {
            loginToggler.addEventListener('click', toggleLogin);
            window.addEventListener('resize', offsetLogin);
            window.addEventListener('orientationchange', offsetLogin);
            offsetLogin();
        }

        function toggleLogin() {
            document.dispatchEvent(new Event('rb.login.toggle'));
        }

        function offsetLogin() {
            const box = loginToggler.getBoundingClientRect();
            login.style.left = box.left + 'px';
        }
    }
}


/**
 *
 * @param {HTMLElement} entry
 * @param {number} eidx
 * @param {HTMLElement[]} topEntries
 */
function initDesktopTopEntry(entry, eidx, topEntries) {
    const entryLink = entry.querySelector('.-entry-link');

    if (entry.classList.contains('has--dropdown')) {
        initDropDown();
    }

    entry.addEventListener('rb.trigger', () => {
        entryLink.focus();
    });

    entryLink.addEventListener('keydown', event => {
        switch (KKey.getCode(event)) {
            case KKey.ArrowLeft:
                if (eidx) {
                    topEntries[eidx - 1].dispatchEvent(new Event('rb.trigger'));
                }
                break;
            case KKey.ArrowRight:
                if (eidx < topEntries.length - 1) {
                    topEntries[eidx + 1].dispatchEvent(new Event('rb.trigger'));
                }
                break;
            default:
                return true;
        }
        event.preventDefault();
    });

    function initDropDown() {
        const submenu      = entry.querySelector('.-entry-submenu'),
              // mainLink = submenu.querySelector('.-mainLink'),
              subLinks     = [].slice.apply(submenu.querySelectorAll('.-section-entry-link')),
              sectionParts = [].slice.apply(submenu.querySelectorAll('.-section-part')).map(part => {
                  return {
                      part,
                      partLinks: [].slice.apply(part.querySelectorAll('.-section-entry-link')),
                  };
              });
        const firstFocusableElement = subLinks[0];
        const lastFocusableElement = subLinks[subLinks.length - 1];

        document.addEventListener('click', event => {
            if (isOpen() && !entry.contains(event.target)) {
                close();
            }
        });

        entry.addEventListener('keydown', event => {
            if (event.keyCode === KKey.Escape) {
                event.preventDefault();
                close();
            }
            
            if (event.keyCode === KKey.Tab) {
                if (event.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        event.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        event.preventDefault();
                    }
                }
            }
            
        });

        entry.addEventListener('rb.trigger', () => {
            open();
        });

        entryLink.addEventListener('click', event => {
            event.preventDefault();
            toggle();
        });

        entryLink.addEventListener('keydown', event => {
            switch (KKey.getCode(event)) {
                case KKey.Spacebar:
                case KKey.Enter:
                    toggle();
                    break;
                case KKey.ArrowDown:
                    open();
                    // mainLink.focus()
                    subLinks[0].focus();
                    break;
                case KKey.ArrowUp:
                    open();
                    if (links.length) {
                        links[links.length - 1].focus();
                    }
                    break;
                case KKey.ArrowRight:
                    if (eidx < topEntries.length - 1) {
                        close();
                    }
                    break;
                case KKey.ArrowLeft:
                    if (eidx) {
                        close();
                    }
                    break;
                default:
                    return true;
            }
            event.preventDefault();
        });

        // mainLink.addEventListener('keydown', event => {
        //     if (event.keyCode === KKey.ArrowUp) {
        //         close()
        //     } else if (event.keyCode === KKey.ArrowDown && subLinks.length) {
        //         subLinks[0].focus()
        //     } else {
        //         return true
        //     }
        //     event.preventDefault()
        // })

        sectionParts.forEach(({
                                  part,
                                  partLinks,
                              }, pidx) => {
            partLinks.forEach((partLink, idx) => {
                partLink.addEventListener('keydown', event => {
                    let lnk = null;
                    switch (KKey.getCode(event)) {
                        case KKey.ArrowLeft:
                            lnk = getPartLink(getPrevPart(pidx), idx);
                            break;
                        case KKey.ArrowRight:
                            lnk = getPartLink(getNextPart(pidx), idx);
                            break;
                    }
                    if (lnk) {
                        event.preventDefault();
                        lnk.focus();
                    }
                });
            });

            function getPrevPart(idx) {
                if (!idx) {
                    return sectionParts[sectionParts.length - 1];
                } else {
                    return sectionParts[idx - 1];
                }
            }

            function getNextPart(idx) {
                if (idx < sectionParts.length - 1) {
                    return sectionParts[idx + 1];
                } else {
                    return sectionParts[0];
                }
            }

            function getPartLink(part, idx) {
                if (part.partLinks[idx]) {
                    return part.partLinks[idx];
                } else if (part.partLinks.length) {
                    return part.partLinks[part.partLinks.length - 1];
                }
            }
        });

        subLinks.forEach((subLink, idx) => {
            subLink.addEventListener('keydown', event => {
                switch (KKey.getCode(event)) {
                    case KKey.ArrowUp:
                        if (idx) {
                            subLinks[idx - 1].focus();
                        } else {
                            // mainLink.focus()
                            close();
                        }
                        break;
                    case KKey.ArrowDown:
                        if (idx >= subLinks.length - 1) {
                            // mainLink.focus()
                            subLinks[0].focus();
                        } else if (subLinks[idx + 1]) {
                            subLinks[idx + 1].focus();
                        }
                        break;
                    default:
                        return true;
                }
                event.preventDefault();
            });
        });

        function toggle() {
            isOpen() ? close() : open();
        }

        function open() {
            entry.classList.add('is--pressed');
            // subLinks.concat(mainLink).forEach(lnk => lnk.setAttribute('tabindex', '0'))
            subLinks.forEach(lnk => lnk.setAttribute('tabindex', '0'));
            entryLink.setAttribute('aria-expanded', 'true');
        }

        function close() {
            entry.classList.remove('is--pressed');
            // subLinks.concat(mainLink).forEach(lnk => lnk.setAttribute('tabindex', '-1'))
            subLinks.forEach(lnk => lnk.setAttribute('tabindex', '-1'));
            entryLink.setAttribute('aria-expanded', 'false');
            entryLink.focus();
        }

        function isOpen() {
            return entry.classList.contains('is--pressed');
        }
    }
}
